import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HasystemsettingsService {

  constructor(private http: HttpClient) { }

  getSystemSettingsData() {
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/SystemSettings/systemSettings');
  }

  // uploadLogo(File: File) {
  //   const data: FormData = new FormData();
  //   data.append("ImageData", File);
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json');
  //   headers.append('Content-Type', 'multipart/form-data');
  //   return this.http.post(globalAdd.Paneladdress + 'api/Ha/SystemSettings/uploadLogo',  data , { headers, reportProgress: true, observe: 'events' });
  // }

  // uploadHeaderImage(File: File) {
  //   const data: FormData = new FormData();
  //   data.append("ImageData", File);
  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'application/json');
  //   headers.append('Content-Type', 'multipart/form-data');
  //   return this.http.post(globalAdd.Paneladdress + 'api/Ha/ReportSettings/uploadHeaderImage', data, { headers, reportProgress: true, observe: 'events' });
  // }

  uploadImage(File: File, type: string) {
    const data: FormData = new FormData();
    data.append("imageData", File);
    data.append("type", type);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/SystemSettings/uploadSettingImage', data, { headers, reportProgress: true, observe: 'events' });
  }

  uploadVideo(File: File) {
    const data: FormData = new FormData();
    data.append("VideoData", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/SystemSettings/uploadVideo', data, { headers, reportProgress: true, observe: 'events' });
  }

  uploadText(value: string, type: number) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/SystemSettings/updateSettingText', { text: value, type: type });
  }

}
